/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Button = styled.button`
  display: inline-block;
  background: transparent;
  border: solid 1px transparent;
  line-height: 1;
  padding: 0;

  :focus {
    outline: 0;
    box-shadow: 0 0 3px #0070D2;
  }
`;

const SVG = styled.svg`
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
  fill: ${(p) => p.fill ? p.fill : '#54698d'};

  :hover {
    fill: ${(p) => p.hoverFill ? p.hoverFill : '#0070D2'};
  }
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const UtilityIconButton = ({ className, onClick, icon, size, fill, ariaLabel }) => (
  <Button className={className} onClick={onClick} aria-label={ariaLabel} >
    <SVG size={size} fill={fill}>
      <use xlinkHref={`/assets/icons/utility-sprite/svg/symbols.svg#${icon}`}></use>
    </SVG>
  </Button>
);

UtilityIconButton.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  ariaLabel: PropTypes.string
};

UtilityIconButton.defaultProps = {
  show: true,
};

export default UtilityIconButton;
